import { RouteObject } from 'react-router';
import { ContactUsPage } from '@common/contact/contact-us-page';
import { BusinessPage } from '@common/business/business-page';
import { EncryptionPage } from '@common/encryption/encryption-page';
import { CustomPageLayout } from '@common/custom-page/custom-page-layout';
import { NotFoundPage } from '@common/ui/not-found-page/not-found-page';
import React from 'react';

export const commonRoutes: RouteObject[] = [
  {
    path: 'contact',
    element: <ContactUsPage />,
  },

  {
    path: 'business',
    element: <BusinessPage />,
  },

  {
    path: 'encryption',
    element: <EncryptionPage />,
  },

  {
    path: 'pages/:pageSlug',
    element: <CustomPageLayout />,
  },
  {
    path: 'pages/:pageId/:pageSlug',
    element: <CustomPageLayout />,
  },
  {
    path: '404',
    element: <NotFoundPage />,
  },
];
